// Query keys shared between PostFundedDashboard/queries and hooks that need them
// (e.g. useApplication). Kept standalone to avoid an import cycle between those modules.
export const DOCUMENTS_KEY = ["application_documents"];
